"use client"
import React from "react";
import HeadingSection from "../others/HeadingSection";
import { openModal } from "@/redux/features/GoldInvestModal/goldInvestModalSlice";
import { useDispatch } from "react-redux";

export default function GoldBenifitsSection() {
  const dispatch = useDispatch();

  const rows = [
    {
      title: "Storage",
      digital: "Secure vault, insured",
      physical: "Needs locker, risk of theft",
    },
    {
      title: "Liquidity",
      digital: "Instant online buy/sell",
      physical: "Manual resale process",
    },
    {
      title: "Purity",
      digital: "24K (99.9%) guaranteed",
      physical: "Varies by jeweller",
    },
    {
      title: "Charges",
      digital: "No making charges",
      physical: "5–15% making/wastage",
    },
    {
      title: "Investment Size",
      digital: "Start from ₹100",
      physical: "Higher minimum amount",
    },
    {
      title: "Transparency",
      digital: "Market-linked live price",
      physical: "Price differs by store",
    },
  ];

  return (
    <>
      <div className="mb-10 px-2.5">
        <HeadingSection heading="Benefits of Investing in Digital Gold" subHeading="Learn why digital gold offers more safety and flexibility than physical gold." />
      </div>

      <div className="w-full rounded-2xl overflow-hidden border border-[#333] text-center text-white">
        <div className="bg-[#232220] xs:bg-transparent grid grid-cols-2 xs:grid-cols-3 font-semibold text-lg sm:text-xl md:text-2xl mb-4 xs:mb-0">
          <div className="hidden xs:block py-6" />
          <div className="py-4 xs:py-6 relative xs:bg-[linear-gradient(90deg,#BE9200_0%,#FFFFFF_53.4%,#FFED63_100%)]">
            <div className="hidden xs:block absolute inset-x-0.5 top-0.5 bottom-0 bg-black" />
            <span className="relative z-10 text-white font-semibold">Digital Gold</span>
          </div>
          <div className="py-4 xs:py-6">Physical Gold</div>
        </div>

        {rows.map((row, i) => (
          <div key={i} className="grid grid-cols-2 xs:grid-cols-3 text-gray-300 text-2xs sm:text-base md:text-xl px-3 xs:p-0 mb-4 xs:mb-0">
            <div className="relative bg-transparent xs:bg-[#4A4A4A] text-center xs:text-left col-span-2 xs:col-span-1 text-2sm sm:text-base md:text-xl ">
              <div className="hidden xs:block absolute inset-x-0 top-0.5 bottom-0 bg-black" />
              <div className="relative xs:py-6 xs:px-11 mb-3 xs:mb-0 text-white font-semibold">{row.title}</div>
            </div>

            <div className="relative bg-[linear-gradient(90deg,#BE9200_0%,#FFFFFF_53.4%,#FFED63_100%)] rounded-tl-4xl rounded-bl-4xl xs:rounded-none">
              <div className={`absolute top-0.5 inset-x-0.5 bg-black rounded-tl-4xl rounded-bl-4xl xs:rounded-none ${i === rows.length - 1 ? "bottom-0.5" : "bottom-0.5 xs:bottom-0"}`} />
              <div className="relative p-5 xs:py-6 xs:px-4 text-white h-full flex xs:block justify-center items-center">{row.digital}</div>
            </div>

            <div className="relative bg-[#4A4A4A] rounded-tr-4xl rounded-br-4xl xs:rounded-none">
              <div className="absolute left-0 right-0.5 xs:inset-x-0 top-0.5 rounded-tr-4xl rounded-br-4xl xs:rounded-none bottom-0.5 xs:bottom-0 bg-black" />
              <div className="relative p-5 xs:py-6 xs:px-4 text-white h-full flex xs:block justify-center items-center">{row.physical}</div>
            </div>
          </div>
        ))}
      </div>

      <button onClick={() => dispatch(openModal())} className="block w-fit mx-auto text-2sm sm:text-base bg-[#C89900] text-white font-medium px-6 py-3 rounded-xl shine-button-hover mt-8 sm:mt-10">
        Start with ₹100 today
      </button>
    </>
  );
}
